import React from 'react';
import { Route } from 'react-router-dom';

// Provides a way to issue a server side redirect from within our component tree
const ssRedirect = nextUrl => (
  <Route
    render={({ staticContext }) => {
      if (staticContext) {
        // eslint-disable-next-line no-param-reassign
        staticContext.status = 302;
        // eslint-disable-next-line no-param-reassign
        staticContext.url = nextUrl;
      }

      return false;
    }}
  />
);

export default ssRedirect;
